import { SIGNUP_SEARCH_PARAM, USETPA_SEARCH_PARAM } from "@/consts";
import { IS_CAFE_COOKIE, NX_SIGNUP_COOKIE, NX_TPA_COOKIE } from "@/consts/cookies";
import { getCookies, getIsForcedNonCafe, getSearchParams, setCookie } from "@/lib/utils";
import { createContext, useContext } from "react";
import { createStore, useStore } from "zustand";

type CookieStoreStateType = {
  isCafe: boolean;
  usetpa: string | number;
  signup: number;
};
type CookieStoreActionType = {
  setIsCafe: (isCafe: boolean) => void;
  setUsetpa: (usetpa: string | number) => void;
  setSignup: (signup: number) => void;
};
type CookieStoreType = CookieStoreStateType & CookieStoreActionType;

export const createCookieStore = (initialProps?: Partial<CookieStoreStateType>) => {
  const defaultProps = {
    isCafe: getIsForcedNonCafe() ? false : getCookies(IS_CAFE_COOKIE) === "true",
    usetpa: initialProps?.usetpa ?? getSearchParams(USETPA_SEARCH_PARAM) ?? "-",
    signup: initialProps?.signup ?? Number(getSearchParams(SIGNUP_SEARCH_PARAM) ?? -1),
  };

  setCookie(NX_SIGNUP_COOKIE, defaultProps.signup.toString());
  setCookie(NX_TPA_COOKIE, defaultProps.usetpa.toString());

  return createStore<CookieStoreType>((set) => ({
    ...defaultProps,
    setIsCafe: (isCafe: boolean) => {
      setCookie(IS_CAFE_COOKIE, isCafe ? "true" : "false", 1);
      return set({ isCafe });
    },
    setUsetpa: (usetpa: string | number) => {
      setCookie(NX_TPA_COOKIE, usetpa.toString());
      return set({ usetpa });
    },
    setSignup: (signup: number) => {
      setCookie(NX_SIGNUP_COOKIE, signup.toString());
      return set({ signup });
    },
  }));
};

export const CookieContext = createContext<ReturnType<typeof createCookieStore> | null>(null);

const CookieStore = <T>(selector: (state: CookieStoreType) => T): T => {
  const store = useContext(CookieContext);
  if (!store) throw new Error("Missing CookieContext.Provider in the tree");
  return useStore(store, selector);
};

export default CookieStore;
